import { translate} from "../../../utils/Common";
import { useLocation } from "react-router-dom";
import { verifyAccessViewPermissions } from "../../../config/permissions";

import {
  FaUserFriends,
} from "react-icons/fa";

import { ImProfile } from "react-icons/im";
import { MdDateRange, MdOutlineMailOutline, MdPhone } from "react-icons/md";
import { IoIosSave, IoIosSettings, IoMdPersonAdd } from "react-icons/io";

import ProviderList from "../../../components/ProviderList";
import { useClient } from "../../../hooks/useClient";
import { useCallback, useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form/dist/index.ie11";
import ModalContext from "../../../contexts/modal";

import "./index.css";
import RoleBliSelect from "../../../components/Selects/RoleBliSelect";

const CreateClient = () => {
  const { createClient } = useClient();
  const [optionSelect, setOptionSelect] = useState("");
  const [isServerRun, setIsServerRun] = useState(true);
  const location = useLocation();
  const permissionsPath = "/dashboard/clients";
  const canCreate = verifyAccessViewPermissions(["create"], { path: permissionsPath || location.pathname });

  const modalContext = useContext(ModalContext);
  const [providor, setProvidor] = useState(null);

  const { register, handleSubmit, errors, setValue, reset, setError } = useForm();

  const handleCreateClient = async (data) => {
    if (!canCreate) return;
    const abortController = new AbortController();
    const response = await createClient(abortController.signal, data);

    switch (response) {
      case "SIGNUP_SUCCESSFULLY":
        handleResetForm();
        setIsServerRun(true);
        modalContext.confirm(
          translate("global.alert.ready"),
          <span>{translate("global.clientCreateSuccess")}</span>,
          [
            <button
              key={2}
              type="button"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground"
              onClick={() => {
                modalContext.setIsOpenModal(false);
              }}
            >
              {translate("global.OK")}
            </button>,
          ],
          true
        );
        break;
      case "USERNAME_ALREADY_EXIST":
        setError("user", {
          type: "focus",
          message: translate("login.signup.validate.userExist"),
        });
        setIsServerRun(true);


        break;
      case "EMAIL_ALREADY_EXIST":
        setError("email", {
          type: "focus",
          message: translate("login.signup.validate.emailExist"),
        });
        setIsServerRun(true);
        break;

      case "SERVER_ERROR":
        setIsServerRun(false);

        modalContext.confirm(
          translate("global.alert.attention"),
          <span>{translate("login.signup.validate.serverError")}</span>,
          [
            <button
              key={2}
              type="button"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground"
              onClick={() => {
                modalContext.setIsOpenModal(false);
              }}
            >
              {translate("global.OK")}
            </button>,
          ],
          true
        );

        break;

      default:
        break;
    }

  };

  // -------------------------

  const handleResetForm = () => {
    reset();
    setProvidor(null);
    setOptionSelect("");
  };

  const renderBtnsCreate = () => (
    <div className="flex mt-3">
      <button
        className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90 h-8 rounded-md px-3 text-xs"
        // disabled={isDisabled}
        type="submit"
      >
        <IoIosSave size={18} className="mr-1" /> {translate("global.save")}
      </button>
      <a href="/dashboard/clients"
        className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground h-8 rounded-md px-3 text-xs ml-2"
        onClick={() => handleResetForm()}
        type="button"
      >
        {translate("global.goBack")}
      </a>
    </div>
  );


  const handleSubmitCreate = (data) => {
    if(!providor){
      setError('proveedor', { type: 'focus', message: 'Seleccione una empresa' });
    }else{
      handleCreateClient({...data, proveedor: providor.IdUsuario});
    }
  };

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () =>
      window.innerWidth < 1040 ? setIsMobile(true) : setIsMobile(false);

    window.addEventListener("resize", handleResize);

    if (window.innerWidth < 1040) setIsMobile(true);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {!canCreate ? (
        <div style={{ padding: "15px 25px" }}>
          <div className="box-card-general mt-2">
            <div className="details-section-general">
              <div style={{ padding: "1rem" }}>
                <h5 style={{ marginBottom: 6 }}>
                  {translate("dashboard.configuration.noPermissionTitle")}
                </h5>
                <div style={{ color: "var(--text-secondary, #6B7280)" }}>
                  {translate("dashboard.clients.formSearch.NOT_ACCESS")}
                </div>
                <div style={{ marginTop: 12 }}>
                  <a href="/dashboard/clients" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90 h-8 rounded-md px-3 text-xs" type="button">
                    {translate("global.goBack")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          {/* Header */}
          <div
            style={{
              position: "sticky",
              top: "0",
              backdropFilter: "blur(8px)",
              zIndex: 15,
              display: "flex",
              justifyContent: "space-between",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              padding: "15px 25px 0",
            }}
          >
            <div className="flex justify-between">
              <div className="text-left flex" style={{ alignContent: "center" }}>
                <a href="/dashboard/clients">
                  <h5 className="link-hover-effect">
                    <FaUserFriends size={18} className="mr-2" />
                    {translate("global.clients")}
                  </h5>
                </a>
                <span className="ml-1 mt-1"> {" > "} {translate("global.createClient")}</span>
              </div>
            </div>
          </div>

          <div
            style={{
              padding: " 0 15px ",
              marginBottom: "50px",
              background: "#fcfcfc",
            }}
            className="h-full w-full"
          >
            <div className="box-card-general mt-2">
              <div className="details-section-general">
              <form onSubmit={handleSubmit(handleSubmitCreate)}>
             <div className="ml-4 flex items-center" id="subtitle-createClient"> 
               <IoMdPersonAdd id="subtitle-createClient" className="mr-2" size={25}/>
               <h3 id="subtitle-createClient" >{translate("global.createClient")}</h3>
             </div>
            <div className="details-section-information" style={{display:"flex", flexDirection: isMobile ? "column" : "row", gap:"20px"}}>
                {/* Informacion Personal - View */}
                <div className="details-section-info-group"  >
                  <div className="box-card-general-dash w-full">
                    <h6>
                      <ImProfile />{" "}
                      {translate("dashboard.userprofile.personal.title")}
                    </h6>

                    <div className="flex flex-wrap">
                      <div className="details-info lg:w-6/12 md:w-6/12 sm:w-full">
                        <div className="details-info-label">
                          {translate("global.name")} <span className="text-destructive">*</span>
                        </div>

                        <input
                          type="text"
                          className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed h-9 text-sm mt-2"
                          name="name"
                          ref={register}
                          required
                        />
                      </div>

                      <div className="details-info lg:w-6/12 md:w-6/12 sm:w-full">
                        <div className="details-info-label">
                          {translate("global.lastNames")} <span className="text-destructive">*</span>
                        </div>

                        <input
                          type="text"
                          className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed h-9 text-sm mt-2"
                          name="lastName"
                          ref={register}
                          required
                        />
                      </div>

                      <div className="details-info lg:w-6/12 md:w-6/12 sm:w-full">
                        <div className="details-info-label">
                          <MdOutlineMailOutline className="mr-1" size={18} />
                          {translate("global.email")} <span className="text-destructive">*</span>
                        </div>

                        <input
                          type="email"
                          className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed h-9 text-sm mt-2"
                          name="email"
                          required
                          ref={register}
                        />

                                    {errors.email && <p className="text-destructive mt-2">{errors.email.message}</p>}
                      </div>

                      <div className="details-info lg:w-6/12 md:w-6/12 sm:w-full">
                        <div className="details-info-label">
                          <MdPhone className="mr-1" size={18} />
                          {translate("global.phone")}
                        </div>

                        <input
                          type="text"
                          className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed h-9 text-sm mt-2"
                          name="phone"
                          ref={register}
                        />
                      </div>

                      <div className="details-info lg:w-6/12 md:w-6/12 sm:w-full">
                        <div className="details-info-label">
                          <MdDateRange className="mr-1" size={18} />{" "}
                          {translate(
                            "dashboard.userprofile.personal.birthdate_label"
                          )}
                        </div>

                        <input
                          type="date"
                          className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed h-9 text-sm mt-2"
                          name="birthDate"
                          ref={register}
                          autoComplete="bday"
                        />
                      </div>

                      <div className="details-info lg:w-6/12 md:w-6/12 sm:w-full">
                        <div className="details-info-label">
                          {translate("global.gender")}
                        </div>

                        <select
                          className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed h-9 text-sm mt-2"
                          name="gender"
                          ref={register}
                        >
                           <option value="H">{translate("global.select")}</option>
                          <option value="H">{translate("global.male")}</option>
                          <option value="M">
                            {translate("global.female")}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                 {/* Other Info Client - View */}
                 <div className="details-section-info-group"
                >
                  <div className="box-card-general-dash w-full" style={{justifyContent:"start"}}>
                    <h6>
                    <IoIosSettings />{" "}
                      {translate("global.otherInfo")}
                    </h6>

                    <div className="flex flex-wrap">

                      
<div className="details-info w-full">
          
          <div className="details-info-label mb-2">
                      {translate("global.business")} <span className="text-destructive">*</span>
                    </div>
        <ProviderList
                register={register}
                errors={errors}
                nameShow={translate("global.select")}
                readOnly={false}
                setValue={setValue}
                valueId={"proveedor"}
                setProveedor={setProvidor}
                idShow={"all"}
              />

        </div>

                      <div className="details-info lg:w-6/12 md:w-6/12 sm:w-full">
                        <div className="details-info-label">
                          {translate("login.signin.user")} <span className="text-destructive">*</span>
                        </div>

                        <input
                          type="text"
                          className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed h-9 text-sm mt-2"
                          name="user"
                          ref={register}
                          required
                        />
                        {errors.user && <p className="text-destructive mt-2">{errors.user.message}</p>}
                      </div>

                      <div className="details-info lg:w-6/12 md:w-6/12 sm:w-full">
                        <div className="details-info-label">
                          {translate("global.role")} BLI <span className="text-destructive">*</span>
                        </div>

                        <RoleBliSelect  register={register} isRequerid={true}/>
                      </div>


                    </div>
                  </div>
                </div>
                
         

            </div>
            <div className="mb-2" style={{display: "flex", justifyContent:"end"}}>
                    {renderBtnsCreate()}
                </div>
              </form>
          </div>
        </div>
      </div>
        </>
      )}
    </>
  );
};

export default CreateClient;
